import {
  ConsumablePricingItem as ConsumablePricingItemSynthesisCore,
  DeviceConsumablePricingItem as DeviceConsumablePricingItemSynthesisCore,
  DeviceConsumableWithSuppPricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore,
  DevicePricingItem as DevicePricingItemSynthesisCore,
  EnumPricingItemType as EnumPricingItemTypeSynthesisCore,
  EnumQuoteType,
  OptionPricingItem as OptionPricingItemSynthesisCore,
  PackPricingItem as PackPricingItemSynthesisCore,
  PricingItem as PricingItemSynthesisCore,
} from 'quote-export-manager-core';
import {PricingItem} from '../../../core/models/quote/pricing-item/pricing-item';
import {EnumPricingItemType} from '../../../core/models/quote/pricing-item/pricing-item-type';
import {DevicePricingItem} from '../../../core/models/quote/pricing-item/device-pricing-item';
import {ConsumablePricingItem} from '../../../core/models/quote/pricing-item/consumable-pricing-item';
import {DeviceConsumablePricingItem} from '../../../core/models/quote/pricing-item/device-consumable-pricing-item';
import {PackPricingItem} from '../../../core/models/quote/pricing-item/pack-pricing-item';
import {DeviceConsumableWithSuppPricingItem} from '../../../core/models/quote/pricing-item/device-consumable-with-supp-pricing-item';
import {OptionPricingItem} from '../../../core/models/quote/pricing-item/option-pricing-item';
import {OptionV1Mapper} from './option-v1.mapper';
import {Injectable} from '@angular/core';

@Injectable()
export class PricingItemV1Mapper {
  constructor(private readonly optionV1Mapper: OptionV1Mapper) {}

  toPricingItem(item: PricingItem): PricingItemSynthesisCore {
    let pricingItem: PricingItemSynthesisCore;

    switch (item.pricingItemType) {
      case EnumPricingItemType.DEVICE:
        pricingItem = new DevicePricingItemSynthesisCore() as DevicePricingItemSynthesisCore;
        (pricingItem as DevicePricingItemSynthesisCore).device = (item as DevicePricingItem).device;
        (pricingItem as DevicePricingItemSynthesisCore).initialStockLS = (item as DevicePricingItem).initialStockLS;
        (pricingItem as DevicePricingItemSynthesisCore).initialstockBillLS = (item as DevicePricingItem).initialstockBillLS;
        (pricingItem as DevicePricingItemSynthesisCore).unitStockInitialVT = (item as DevicePricingItem).unitStockInitialVT;
        (pricingItem as DevicePricingItemSynthesisCore).totalStockInitialVT = (item as DevicePricingItem).totalStockInitialVT;
        (pricingItem as DevicePricingItemSynthesisCore).collectorExtraPrice =
            (item as DevicePricingItem).collectorExtraPrice;
            
        break;
      case EnumPricingItemType.CONSUMABLE:
        pricingItem = new ConsumablePricingItemSynthesisCore() as ConsumablePricingItemSynthesisCore;
        (pricingItem as ConsumablePricingItemSynthesisCore).consumable = (item as ConsumablePricingItem).consumable;
        (pricingItem as ConsumablePricingItemSynthesisCore).consumableExtraPrice =
            (item as ConsumablePricingItem).consumableExtraPrice;
        break;
      case EnumPricingItemType.DEVICE_CONSUMABLE:
        pricingItem =
          new DeviceConsumablePricingItemSynthesisCore() as DeviceConsumablePricingItemSynthesisCore;
        (pricingItem as DeviceConsumablePricingItemSynthesisCore).device = (item as DeviceConsumablePricingItem).device;
        (pricingItem as DeviceConsumablePricingItemSynthesisCore).consumable =
            (item as DeviceConsumablePricingItem).consumable;
        (pricingItem as DeviceConsumablePricingItemSynthesisCore).consumableExtraPrice =
            (item as DeviceConsumablePricingItem).consumableExtraPrice;
        (pricingItem as DeviceConsumablePricingItemSynthesisCore).specificities =
            (item as DeviceConsumablePricingItem).specificities;
        (pricingItem as DeviceConsumablePricingItemSynthesisCore).franchise = (item as DeviceConsumablePricingItem).franchise;
        (pricingItem as DeviceConsumablePricingItemSynthesisCore).discount = (item as DeviceConsumablePricingItem).discount;
        break;
      case EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP:
        pricingItem =
            new DeviceConsumableWithSuppPricingItemSynthesisCore() as DeviceConsumableWithSuppPricingItemSynthesisCore;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).device = (item as DeviceConsumableWithSuppPricingItem).device;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).consumable =
            (item as DeviceConsumableWithSuppPricingItem).consumable;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).consumableExtraPrice =
            (item as DeviceConsumableWithSuppPricingItem).consumableExtraPrice;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).specificities =
            (item as DeviceConsumableWithSuppPricingItem).specificities;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).franchise = (item as DeviceConsumableWithSuppPricingItem).franchise;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).discount = (item as DeviceConsumableWithSuppPricingItem).discount;
        (pricingItem as DeviceConsumableWithSuppPricingItemSynthesisCore).additionalConsumablePrice = (item as DeviceConsumableWithSuppPricingItem).additionalConsumablePrice;
        break;
      case EnumPricingItemType.PACK:
        pricingItem = new PackPricingItemSynthesisCore() as PackPricingItemSynthesisCore;
        (pricingItem as PackPricingItemSynthesisCore).device = (item as PackPricingItem).device;
        break;
      case EnumPricingItemType.OPTION:
        pricingItem = new OptionPricingItemSynthesisCore() as OptionPricingItemSynthesisCore;
        (pricingItem as OptionPricingItemSynthesisCore).option = this.optionV1Mapper.toOption(item as OptionPricingItem);
        break;
      default:
        throw new Error(
          `Unknown EnumPricingItemType: ${item.pricingItemType}`,
        );
    }

    pricingItem.id = item.id;
    pricingItem.productType = item.isCmc ? EnumQuoteType.CMC : EnumQuoteType.STANDARD;
    (pricingItem as any).family = item.family ?? (item as any).category;
    pricingItem.isValid = item.isValid;
    pricingItem.userInputs = item.userInputs;
    pricingItem.prefilledInputs = item.prefilledInputs;
    pricingItem.pricingItemType = this.mapEnumPricingItemType(
      item.pricingItemType,
    );
    pricingItem.totalAppliedPrice = item.totalAppliedPrice;
    pricingItem.displayOrder = item.displayOrder;

    return pricingItem;
  }

  mapEnumPricingItemType(type: EnumPricingItemType): EnumPricingItemTypeSynthesisCore {
    switch (type) {
      case EnumPricingItemType.DEVICE:
        return EnumPricingItemTypeSynthesisCore.DEVICE;
      case EnumPricingItemType.CONSUMABLE:
        return EnumPricingItemTypeSynthesisCore.CONSUMABLE;
      case EnumPricingItemType.DEVICE_CONSUMABLE:
        return EnumPricingItemTypeSynthesisCore.DEVICE_CONSUMABLE;
      case EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP:
        return EnumPricingItemTypeSynthesisCore.DEVICE_CONSUMABLE_WITH_SUPP;
      case EnumPricingItemType.PACK:
        return EnumPricingItemTypeSynthesisCore.PACK;
      case EnumPricingItemType.OPTION:
        return EnumPricingItemTypeSynthesisCore.OPTION;
      default:
        throw new Error(`Unknown EnumPricingItemType: ${type}`);
    }
  }
}
